<template>
  <div>
    <div class="filter">
      <div class="row">
        <div class="col-2">
          <div class="form-group">
            <label for="title">Nosaukums</label>
            <select name="title" id="title" v-model="filter_title" class="form-control">
              <option value="">Visi nosaukumi</option>
              <option v-for="title in item_titles" :key="'title'+title.id" :value="title.id">{{title.title}}</option>
            </select>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <label for=collection>Kolekcija</label>
            <select name=collection id="collection" v-model="filter_collection" class="form-control">
              <option value="">Visas kolekcijas</option>
              <option v-for="collection in item_collections" :key="'collection'+collection.id" :value="collection.id">{{collection.title}}</option>
            </select>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <label for="collection">Saturs zinātniskajā aprakstā</label>
            <tags-input element-id="filter_description"
                        v-model="filter_description"
                        :typeahead="false"
                        placeholder="rakstiet vārdus atdalot ar komatu"
                        :add-tags-on-comma="true"
                        :add-tags-on-blur="true"
            ></tags-input>
          </div>
        </div>
        <div class="col-2">
          <label for="filterDateFrom">Datums no</label>
          <v-date-picker
              :popover="{ visibility: 'click' }"
              mode="single"
              v-model="filter_date_from"
              :type="'date'"
              :locale="'LV'"
              color="teal"
              :masks="{input: ['DD.MM.YYYY']
            }"
          />
          <small class="muted">Tikai jaunajā programmā pievienotājiem</small>
      </div>
      <div class="col-2">
        <label for="filterDateFrom">Datums līdz</label>
        <v-date-picker
            :popover="{ visibility: 'click' }"
            mode="single"
            v-model="filter_date_to"
            :type="'date'"
            :locale="'LV'"
            color="teal"
            :masks="{input: ['DD.MM.YYYY']
            }"
        />
        <small class="muted">Tikai jaunajā programmā pievienotājiem</small>
    </div>
        <div class="col-2">
          <div class="form-group">
            <label for="user">Pievienotājs</label>
            <select name="user" id="user" v-model="filter_author" class="form-control">
              <option value="">Visi darbinieki</option>
              <option v-for="user in users_for_filter" :key="'user'+user.id" :value="user.id">{{user.firstname}} {{user.lastname}}</option>
            </select>
            <small class="muted">Tikai jaunajā programmā pievienotājiem</small>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group text-center">
            <button class="btn btn-primary" @click="getDescriptions()"><i class="fas fa-search"></i> Meklēt</button>
            <button class="btn btn-primary" @click="clearFilter()"><i class="fas fa-times"></i> Notīrīt filtru</button>
          </div>
        </div>
        <div class="col-12 text-center p-2">
            <hr>
              <span class="text-muted">
                Kopā atrasti <strong>{{total_count}}</strong> zinātniskie apraksti
              </span>
        </div>
    </div>
    </div>
    <div class="results">
      <div class="loader" v-show="loading">
        <img src="/images/loading.svg" rel="preload" alt="Notiek ielāde..">
      </div>
      <table class="table table-responsive-xl table-hover ">
        <thead class="bg-primary text-white">
        <tr>
          <th>Attēls</th>
          <th>Priekšmets</th>
          <th>Zinātniskais apraksts</th>
          <th>Zin. apr. pievienotājs</th>
          <th>Priekšmeta pievienotājs</th>
          <th class="text-center">Darbības</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="description in descriptions" :key="description.id">
          <td><img style="max-width:100px;" v-if="description.item && description.item.images.length > 0" :src="'/image/thumb/'+description.item.images[0].file_name"></td>
          <td class="nowrap small">
            <template v-if="description.item">
            <strong>{{description.item.cipher}} {{description.item.item_number}}<span v-if="description.item.item_subnumber">-{{description.item.item_subnumber}}</span></strong><br />
            {{description.item.title_old}}<br />
            {{description.item.collection_old}}<br />
            </template>
          </td>
          <td style="white-space: pre-line;" class="small description">{{description.description}}</td>
          <td class="nowrap small">
            <span v-if="description.author">{{description.author.firstname}} {{description.author.lastname}}</span><span v-else>-</span><br />
            {{normalDate(description.created_at)}}
          </td>
          <td class="nowrap small">
            <span v-if="description.item && description.item.created_by">{{description.item.created_by.firstname}} {{description.item.created_by.lastname}} <br />
            {{normalDate(description.item.created_at)}}</span>
            <span v-else>Nav zināms</span>
          </td>
          <td class="actions">
            <item-view-component
                v-if="description.item"
                :key="'view-component-'+description.item.id"
                :transfer_types="transfer_types"
                :item="description.item"
                :item_titles="item_titles"
                :item_collections ="item_collections "
                :scientific_themes="scientific_themes"
                :ciphers="ciphers"
                :copyrights="copyrights"
                :user="user"
            ></item-view-component>
            <item-edit-component
                :key="'edit-component-'+description.item.id"
                :transfer_types="transfer_types"
                :item="description.item"
                :item_titles="item_titles"
                :item_collections ="item_collections "
                :scientific_themes="scientific_themes"
                :ciphers="ciphers"
                :copyrights="copyrights"
                v-if="description.item && hasPermission(user, 'can_edit_item_details')"
            ></item-edit-component>
            <scientific-description-delete-mark-component :description="description" v-if="hasPermission(user,'can_move_scientific_description_delete_area')"></scientific-description-delete-mark-component>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="pagination" v-if="pagination.show_pagination">
        <div class="pages">
          <div class="page" @click="changePage(1)" v-if="pagination.show_first_page">1</div>
          <div class="delimiter" v-if="pagination.show_first_page_divider">...</div>
          <div class="page" @click="changePage(page)" v-for="page in pagination.prev_pages" :key="page">{{page}}</div>
          <div class="page currentPage"  :key="pagination.current_page">{{pagination.current_page}}</div>
          <div class="page" @click="changePage(page)" v-for="page in pagination.next_pages" :key="page">{{page}}</div>
          <div class="delimiter" v-if="pagination.show_last_page_divider">...</div>
          <div class="page" @click="changePage(pagination.total_page_count)" :key="pagination.total_page_count" v-if="pagination.show_last_page">{{pagination.total_page_count}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['transfer_types','item_titles','item_collections','scientific_themes','ciphers', 'copyrights','user','users_for_filter','list_type'],
  mounted() {
    var that = this;
    setTimeout(() => {
      this.getDescriptions();
    },30);
    EventBus.$on('items_updated', (current_item_id) =>{
      that.getDescriptions(that.pagination.current_page, false);
    });
    //Tika izdzēsti uz dzēšanu atzīmētie zinātniskie apraksti
    EventBus.$on('scientific_descriptions_deleted', (current_item_id) =>{
      that.getDescriptions(that.pagination.current_page, false);
    });
  },
  data()
  {
    return{
      descriptions:[],
      loading: true,
      filter_items_per_page:20,
      pagination:[],
      total_count:"",

      filter_title:"",
      filter_collection:"",
      filter_description:[],
      filter_date_from:"",
      filter_date_to:"",
      filter_author:"",
      filter_delete_state:null,
    }
  },
  methods:{


    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    normalDate(date)
    {
      var d = moment(date).format('DD.MM.YYYY.');
      if(moment(d, 'DD.MM.YYYY.').isValid())
      {
        return d;
      }
      else
      {
        return null;
      }
    },
    hasPermission(user,permission)
    {

      return user.allpermissions.some(function(p) {
        return p.name == permission;
      });
    },
    clearFilter()
    {
      this.filter_title = "";
      this.filter_collection = "";
      this.filter_description = [];
      this.filter_date_from = "";
      this.filter_date_to = "";
      this.filter_author = "";
      this.getDescriptions();
    },
    getDescriptions(page = 1, scroll_top = true){
      this.loading = true;
      var that = this;
      var filterData = {
        page:page,
        items_per_page: that.filter_items_per_page,
        filter_title:that.filter_title,
        filter_collection:that.filter_collection,
        filter_description:that.filter_description,
        filter_date_from:that.filter_date_from,
        filter_date_to:that.filter_date_to,
        filter_author:that.filter_author,
        filter_delete_state:that.filter_delete_state,
        filter_list_type: that.$props.list_type
      };
      axios.post('/dashboard/api/scientific-descriptions',filterData)
          .then(response => {
            that.descriptions = response.data.descriptions;
            that.pagination = response.data.pagination;
            that.total_count = response.data.total_count;
            that.loading = false;
            if(scroll_top == true)
            {
              that.scrollToTop();
            }
          }).catch(err =>{

      })
    },

    changePage(page)
    {
      this.getDescriptions(page)
    },
  }


}
</script>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';

.filter{
  padding: 20px;
  box-shadow: 0 1px 20px rgb(0 0 0 / 20%);
  margin-bottom: 10px;
}

.description{
  word-break: break-all;
}
.nowrap{
  white-space: nowrap;
}
.results{
  position:relative;
  .loader{
    cursor: progress;
    position:absolute;

    width:100%;
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    background:rgba(255,255,255,0.7);
    img{
      width:100px;
      height:100px;
    }

  }
}
.pagination{
  margin-top:20px;
  padding-top:20px;
  border-top:solid 2px #777;
  .pages{
    display:flex;
    margin:auto;
    .page{
      width:32px;
      height:32px;
      margin:0 10px;
      display:flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius:100%;
      font-weight: 700;
      transition: all .2s ease-in-out;
      &:hover{
        background:$blue;
        color:#fff;
      }
    }
    .delimiter{
      width:20px;
      height:32px;
      margin:0 0px;
      display:flex;
      color:#333;
      align-items: center;
      justify-content: center;
    }
    .currentPage{
      background:$blue;
      color:#fff;
      cursor:auto;
    }

  }
}
</style>